import React, { createContext, useContext, useState, ReactNode } from 'react';
import type { AnalysisResult } from '@/types/analysis';

interface AnalysisContextType {
  isOpen: boolean;
  filters: any;
  analysisResult: AnalysisResult | null;
  openAnalysis: (filters: any) => void;
  closeAnalysis: () => void;
  toggleAnalysis: () => void;
  setAnalysisResult: (result: AnalysisResult | null) => void;
  clearAnalysis: () => void;
}

const AnalysisContext = createContext<AnalysisContextType | undefined>(undefined);

export function AnalysisProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState<any>(null);
  const [analysisResult, setAnalysisResult] = useState<AnalysisResult | null>(null);

  const openAnalysis = (newFilters: any) => {
    setFilters(newFilters);
    setIsOpen(true);
  };

  const closeAnalysis = () => {
    setIsOpen(false);
    // Keep filters and analysis results - don't reset them
  };

  const toggleAnalysis = () => {
    setIsOpen(!isOpen);
  };

  const clearAnalysis = () => {
    setFilters(null);
    setAnalysisResult(null);
    setIsOpen(false);
  };

  return (
    <AnalysisContext.Provider
      value={{
        isOpen,
        filters,
        analysisResult,
        openAnalysis,
        closeAnalysis,
        toggleAnalysis,
        setAnalysisResult,
        clearAnalysis,
      }}
    >
      {children}
    </AnalysisContext.Provider>
  );
}

export function useAnalysis() {
  const context = useContext(AnalysisContext);
  if (context === undefined) {
    throw new Error('useAnalysis must be used within an AnalysisProvider');
  }
  return context;
}
